module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Group-chat-dce5f4c19ded69210d9d5c984edea54c.svg";